<template>
  <a :alt="$props.alt" :class="$props.className" :href="getHrefWithQueryParams" :rel="$props.rel" :target="$props.target" :title="$props.title"><slot></slot></a>
</template>
<script>
import { mapGetters } from 'vuex'
import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export default {
  name: 'AnchorWithQueryParams',

  props: {
    alt: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    className: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    href: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    rel: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    target: {
      type: String,
      required: false,
      default() {
        return '_self'
      }
    },
    title: {
      type: String,
      required: false,
      default() {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters({
      pageQueryParams: 'UI/pageQueryParams'
    }),
    getHrefWithQueryParams() {
      return createPathOrURLWithQueryParam({ pathOrURL: this.$props.href, query: this.$route.query })
    }
  }
}
</script>
<style lang="scss"></style>
